export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
   *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
   */
  Upload: { input: any; output: any; }
  /** The `Void` scalar type represents no value being returned. */
  Void: { input: any; output: any; }
}

export interface ActivateBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface ActivateModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface AddCameraToBasicConfiguratorProductInput {
  camera: CameraInput;
  configuratorId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}

export interface AddCameraToModularConfiguratorComponentInput {
  camera: CameraInput;
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface AddEnvironmentToBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  environment: BasicConfiguratorEnvironmentInput;
}

export interface AddEnvironmentToModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  environment: ModularConfiguratorEnvironmentInput;
}

export interface AddProductToBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  product: BasicConfiguratorProductInput;
}

export interface AddProductToModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  product: ModularConfiguratorProductInput;
}

export interface AssetCreationRequest {
  __typename?: 'AssetCreationRequest';
  assetId?: Maybe<Scalars['ID']['output']>;
  assetType?: Maybe<AssetType>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  status: AssetCreationRequestStatus;
}

export enum AssetCreationRequestStatus {
  Completed = 'completed',
  Failed = 'failed',
  New = 'new',
  Validated = 'validated'
}

export enum AssetType {
  Environment = 'environment',
  Material = 'material',
  Product = 'product'
}

export interface BasicConfigurator {
  __typename?: 'BasicConfigurator';
  camera: Camera;
  client: Client;
  ctaEnabled?: Maybe<Scalars['Boolean']['output']>;
  environments: Array<BasicConfiguratorEnvironment>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  productCollectionLabel: Scalars['String']['output'];
  products: Array<BasicConfiguratorProduct>;
}

export interface BasicConfiguratorEnvironment {
  __typename?: 'BasicConfiguratorEnvironment';
  environment: Environment;
  environmentId: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
}

export interface BasicConfiguratorEnvironmentInput {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  position: Scalars['Int']['input'];
}

export interface BasicConfiguratorProduct {
  __typename?: 'BasicConfiguratorProduct';
  camera?: Maybe<Camera>;
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
}

export interface BasicConfiguratorProductInput {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  position: Scalars['Int']['input'];
}

export interface BoundariesBox {
  __typename?: 'BoundariesBox';
  end: RadiusVector;
  start: RadiusVector;
}

export interface BoundariesBoxInput {
  end: RadiusVectorInput;
  start: RadiusVectorInput;
}

export interface Camera {
  __typename?: 'Camera';
  fov: Scalars['Float']['output'];
  mode: Scalars['String']['output'];
  position: RadiusVector;
  restrictions?: Maybe<Restrictions>;
  rotation: Rotation;
}

export interface CameraInput {
  fov: Scalars['Int']['input'];
  mode: CameraMode;
  position: RadiusVectorInput;
  restrictions?: InputMaybe<RestrictionsInput>;
  rotation: RotationInput;
}

export enum CameraMode {
  Fps = 'fps',
  Orbit = 'orbit'
}

export interface CameraPreset {
  __typename?: 'CameraPreset';
  config: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isLocked: Scalars['Boolean']['output'];
  previewPath?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface CameraPresetListType {
  __typename?: 'CameraPresetListType';
  cameraPresets: Array<CameraPreset>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface ChangeBasicConfiguratorEnvironmentLabelInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
}

export interface ChangeBasicConfiguratorEnvironmentPositionInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}

export interface ChangeBasicConfiguratorProductCollectionLabelInput {
  configuratorId: Scalars['ID']['input'];
  productCollectionLabel: Scalars['String']['input'];
}

export interface ChangeBasicConfiguratorProductLabelInput {
  configuratorId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  productId: Scalars['ID']['input'];
}

export interface ChangeBasicConfiguratorProductPositionInput {
  configuratorId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
}

export interface ChangeClientUnrealVersionInput {
  clientId: Scalars['ID']['input'];
  unrealVersion: UnrealVersion;
}

export interface ChangeEnvironmentPreviewFromRenderInput {
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  renderId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ChangeEnvironmentPreviewInput {
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  preview: Scalars['Upload']['input'];
}

export interface ChangeEnvironmentSlotLabelInput {
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface ChangeEnvironmentSunNorthYawInput {
  environmentId: Scalars['String']['input'];
  sunNorthYaw: Scalars['Float']['input'];
}

export interface ChangeEnvironmentTitleInput {
  environmentId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface ChangeEnvironmentUdsHourInput {
  environmentId: Scalars['String']['input'];
  udsHour: Scalars['Float']['input'];
}

export interface ChangeMaterialExternalIdInput {
  externalId?: InputMaybe<Scalars['String']['input']>;
  materialId: Scalars['ID']['input'];
}

export interface ChangeMaterialPreviewInput {
  materialId?: InputMaybe<Scalars['ID']['input']>;
  preview: Scalars['Upload']['input'];
}

export interface ChangeMaterialTitleInput {
  materialId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface ChangeMetaPropertyTypeInput {
  expression?: InputMaybe<Scalars['String']['input']>;
  metaPropertyId: Scalars['ID']['input'];
  type: MetaPropertyTypeInput;
}

export interface ChangeModularConfiguratorComponentPositionInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}

export interface ChangeModularConfiguratorComponentTypePositionInput {
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}

export interface ChangeModularConfiguratorEnvironmentLabelInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
  label: Scalars['String']['input'];
}

export interface ChangeModularConfiguratorEnvironmentPositionInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
}

export interface ChangeModularConfiguratorRootComponentTypeInput {
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface ChangeProductExternalIdInput {
  externalId?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
}

export interface ChangeProductPreviewFromRenderInput {
  productId?: InputMaybe<Scalars['ID']['input']>;
  renderId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ChangeProductPreviewInput {
  preview: Scalars['Upload']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
}

export interface ChangeProductSlotLabelInput {
  label: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  slotId: Scalars['String']['input'];
}

export interface ChangeProductTitleInput {
  productId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface Client {
  __typename?: 'Client';
  hasPublicAssets: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unrealVersion: Scalars['String']['output'];
}

export interface CloneBasicConfiguratorInput {
  cloneName: Scalars['String']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface CloneEnvironmentToClientInput {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  environmentId?: InputMaybe<Scalars['ID']['input']>;
}

export interface CloneMaterialToClientInput {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  materialId?: InputMaybe<Scalars['ID']['input']>;
}

export interface CloneModularConfiguratorInput {
  cloneName: Scalars['String']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface CloneProductToClientInput {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
}

export interface CreateAssetCreationRequestInput {
  chunkNumber: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  totalChunks: Scalars['Int']['input'];
}

export interface CreateAssetCreationRequestOutput {
  __typename?: 'CreateAssetCreationRequestOutput';
  completed: Scalars['Boolean']['output'];
}

export interface CreateBasicConfiguratorInput {
  environments: Array<BasicConfiguratorEnvironmentInput>;
  name: Scalars['String']['input'];
  productCollectionLabel: Scalars['String']['input'];
  products: Array<BasicConfiguratorProductInput>;
}

export interface CreateCameraPresetInput {
  config: Scalars['String']['input'];
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  preview?: InputMaybe<Scalars['Upload']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
}

export interface CreateMetaPropertyInput {
  expression?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: MetaPropertyTypeInput;
}

export interface CreateModularConfiguratorComponentInput {
  camera?: InputMaybe<CameraInput>;
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
  socketToConnectorsMap: Array<ModularConfiguratorComponentSocketToConnectorInput>;
}

export interface CreateModularConfiguratorComponentTypeInput {
  configuratorId: Scalars['ID']['input'];
  isRequired: Scalars['Boolean']['input'];
  isRoot: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
}

export interface CreateModularConfiguratorConnectorInput {
  componentTypeId1: Scalars['ID']['input'];
  componentTypeId2: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface CreateModularConfiguratorFromProductsInput {
  environments: Array<ModularConfiguratorEnvironmentInput>;
  name: Scalars['String']['input'];
  products: Array<ModularConfiguratorProductInput>;
  rootProductTypeId: Scalars['ID']['input'];
}

export interface CreateModularConfiguratorInput {
  environments: Array<ModularConfiguratorEnvironmentInput>;
  name: Scalars['String']['input'];
}

export interface CreatePresetInput {
  config: Scalars['String']['input'];
  environmentId: Scalars['ID']['input'];
  preview?: InputMaybe<Scalars['Upload']['input']>;
  title: Scalars['String']['input'];
}

export interface CreateProductVirtualSocketInput {
  name: Scalars['String']['input'];
  originalSockets: Array<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
}

export interface CreateRenderRequestInput {
  aiMask?: InputMaybe<Scalars['Upload']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  fileType: RenderRequestFileTypeEnum;
  fov: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
  isAsyncMode?: InputMaybe<Scalars['Boolean']['input']>;
  isPathTrace?: InputMaybe<Scalars['Boolean']['input']>;
  isTransparentBackground?: InputMaybe<Scalars['Boolean']['input']>;
  mode: RenderRequestModeEnum;
  preview?: InputMaybe<Scalars['Upload']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sourceRenderId?: InputMaybe<Scalars['ID']['input']>;
  width: Scalars['Int']['input'];
}

export interface CreateSpinnerRequestInput {
  imageCount: Scalars['Int']['input'];
  productId: Scalars['ID']['input'];
}

export interface Date {
  __typename?: 'Date';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
}

export interface DeactivateBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface DeactivateModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteCameraFromModularConfiguratorComponentInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteCameraPresetInput {
  cameraPresetId: Scalars['String']['input'];
}

export interface DeleteComponentFromModularConfiguratorInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteComponentTypeFromModularConfiguratorInput {
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
}

export interface DeleteConnectorFromModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  connectorId: Scalars['ID']['input'];
}

export interface DeleteEnvironmentInput {
  environmentId: Scalars['String']['input'];
}

export interface DeleteMaterialInput {
  materialId?: InputMaybe<Scalars['ID']['input']>;
}

export interface DeleteMetaPropertyInput {
  metaPropertyId: Scalars['ID']['input'];
}

export interface DeleteModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface DeletePresetInput {
  presetId: Scalars['String']['input'];
}

export interface DeleteProductInput {
  productId: Scalars['String']['input'];
}

export interface DeleteProductVirtualSocketInput {
  productId: Scalars['String']['input'];
  virtualSocketId: Scalars['String']['input'];
}

export interface DeleteRenderInput {
  renderId: Scalars['String']['input'];
}

export interface DeleteSpinnerInput {
  spinnerId: Scalars['String']['input'];
}

export interface DisableAllMaterialsForEnvironmentSlotInput {
  environmentId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface DisableAllMaterialsForProductSlotInput {
  productId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface DisableEnvironmentUdsInput {
  environmentId: Scalars['String']['input'];
}

export interface DisableMaterialForEnvironmentSlotInput {
  environmentId: Scalars['String']['input'];
  materialId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface DisableMaterialForProductSlotInput {
  materialId?: InputMaybe<Scalars['ID']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  slotId: Scalars['String']['input'];
}

export interface EnableEnvironmentUdsInput {
  environmentId: Scalars['String']['input'];
}

export interface EnableMaterialForEnvironmentSlotInput {
  environmentId: Scalars['String']['input'];
  materialId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface EnableMaterialForProductSlotInput {
  materialId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
}

export interface EnableMaterialsFromAnotherEnvironmentSlotInput {
  sourceEnvironmentId: Scalars['String']['input'];
  sourceSlotId: Scalars['String']['input'];
  targetEnvironmentId: Scalars['String']['input'];
  targetSlotId: Scalars['String']['input'];
}

export interface EnableMaterialsFromAnotherProductSlotInput {
  sourceProductId: Scalars['String']['input'];
  sourceSlotId: Scalars['String']['input'];
  targetProductId: Scalars['String']['input'];
  targetSlotId: Scalars['String']['input'];
}

export interface Environment {
  __typename?: 'Environment';
  cameraPresets: CameraPresetListType;
  clientId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  legacyAssetId: Scalars['ID']['output'];
  model: Model;
  modelId: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  renders: RenderListType;
  slots: Array<Slot>;
  sunNorthYaw: Scalars['Float']['output'];
  thumbnailList: Array<Thumbnail>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  udsEnabled: Scalars['Boolean']['output'];
  udsHour: Scalars['Float']['output'];
}


export interface EnvironmentCameraPresetsArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface EnvironmentRendersArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GetAssetCreationRequestListInput {
  requestIds: Array<Scalars['ID']['input']>;
}

export interface GetAssetCreationRequestListOutput {
  __typename?: 'GetAssetCreationRequestListOutput';
  assetCreationRequests: Array<AssetCreationRequest>;
}

export interface GetBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface GetBasicConfiguratorListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetBasicConfiguratorListOutput {
  __typename?: 'GetBasicConfiguratorListOutput';
  basicConfigurators: Array<BasicConfigurator>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetClientInput {
  clientId: Scalars['ID']['input'];
}

export interface GetClientListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GetClientListOutput {
  __typename?: 'GetClientListOutput';
  clients: Array<Client>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetEnvironmentInput {
  environmentId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GetEnvironmentListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyWithPresets?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetEnvironmentListOutput {
  __typename?: 'GetEnvironmentListOutput';
  environments: Array<Environment>;
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetMaterialInput {
  materialId: Scalars['ID']['input'];
}

export interface GetMaterialListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetMaterialListOutput {
  __typename?: 'GetMaterialListOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  materials: Array<Material>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetMetaPropertyListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetMetaPropertyListOutput {
  __typename?: 'GetMetaPropertyListOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  metaProperties: Array<MetaProperty>;
  offset?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
}

export interface GetModularConfiguratorListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetModularConfiguratorListOutput {
  __typename?: 'GetModularConfiguratorListOutput';
  limit: Scalars['Int']['output'];
  modularConfigurators: Array<ModularConfigurator>;
  offset: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetPresetListInput {
  countTotal: Scalars['Boolean']['input'];
  environmentId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GetPresetListOutput {
  __typename?: 'GetPresetListOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  presets: Array<Preset>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetProductInput {
  productId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GetProductListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onlyWithSockets?: InputMaybe<Scalars['Boolean']['input']>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}

export interface GetProductListOutput {
  __typename?: 'GetProductListOutput';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  products: Array<Product>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface GetRenderInput {
  renderId?: InputMaybe<Scalars['ID']['input']>;
}

export interface GetRenderListInput {
  countTotal: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface GetRenderRequestInput {
  renderRequestId: Scalars['ID']['input'];
}

export interface GetSpinnerInput {
  spinnerId?: InputMaybe<Scalars['ID']['input']>;
}

export interface IdOutput {
  __typename?: 'IdOutput';
  id?: Maybe<Scalars['ID']['output']>;
}

export interface ImportProductsMetaDataInput {
  chunkNumber: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  totalChunks: Scalars['Int']['input'];
  uploadId: Scalars['ID']['input'];
}

export interface ImportProductsMetaDataOutput {
  __typename?: 'ImportProductsMetaDataOutput';
  completed: Scalars['Boolean']['output'];
  warnings: Array<Scalars['String']['output']>;
}

export interface LinkOriginalSocketInput {
  originalSocket: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  virtualSocketId: Scalars['String']['input'];
}

export interface MapModularConfiguratorComponentSocketToConnectorInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  connectorId: Scalars['ID']['input'];
  virtualSocketId: Scalars['ID']['input'];
}

export interface Material {
  __typename?: 'Material';
  bigThumbnailUrl?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  model: Model;
  modelId: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  smallThumbnailUrl?: Maybe<Scalars['String']['output']>;
  thumbnailList: Array<Thumbnail>;
  title: Scalars['String']['output'];
}

export interface MetaProperty {
  __typename?: 'MetaProperty';
  expression?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export enum MetaPropertyTypeInput {
  Bool = 'bool',
  Float = 'float',
  Int = 'int',
  Regexp = 'regexp',
  String = 'string'
}

export interface Model {
  __typename?: 'Model';
  assetPath: Scalars['String']['output'];
  id: Scalars['String']['output'];
  pakFilePath: Scalars['String']['output'];
  unrealVersion: Scalars['String']['output'];
}

export interface ModularConfigurator {
  __typename?: 'ModularConfigurator';
  camera: Camera;
  client: Client;
  componentTypes: Array<ModularConfiguratorComponentType>;
  components: Array<ModularConfiguratorComponent>;
  connectors: Array<ModularConfiguratorConnector>;
  ctaEnabled?: Maybe<Scalars['Boolean']['output']>;
  environments: Array<ModularConfiguratorEnvironment>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
}

export interface ModularConfiguratorComponent {
  __typename?: 'ModularConfiguratorComponent';
  camera?: Maybe<Camera>;
  componentType?: Maybe<ModularConfiguratorComponentType>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  product: Product;
  virtualSocketToConnectorsMap: Array<ModularConfiguratorVirtualSocketToConnector>;
}

export interface ModularConfiguratorComponentSocketToConnectorInput {
  connectorId: Scalars['String']['input'];
  socketId: Scalars['String']['input'];
}

export interface ModularConfiguratorComponentType {
  __typename?: 'ModularConfiguratorComponentType';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  isRoot: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
}

export interface ModularConfiguratorConnector {
  __typename?: 'ModularConfiguratorConnector';
  componentTypeId1: Scalars['ID']['output'];
  componentTypeId2: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
}

export interface ModularConfiguratorEnvironment {
  __typename?: 'ModularConfiguratorEnvironment';
  environment: Environment;
  environmentId: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
}

export interface ModularConfiguratorEnvironmentInput {
  id: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
}

export interface ModularConfiguratorProductInput {
  id: Scalars['String']['input'];
  position: Scalars['Int']['input'];
}

export interface ModularConfiguratorVirtualSocketToConnector {
  __typename?: 'ModularConfiguratorVirtualSocketToConnector';
  connectorId: Scalars['ID']['output'];
  virtualSocketId: Scalars['ID']['output'];
}

export interface MoveEnvironmentMaterialInput {
  environmentId: Scalars['String']['input'];
  fromPosition: Scalars['Int']['input'];
  slotId: Scalars['String']['input'];
  toPosition: Scalars['Int']['input'];
}

export interface MoveProductMaterialInput {
  fromPosition: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
  slotId: Scalars['String']['input'];
  toPosition: Scalars['Int']['input'];
}

export interface Mutation {
  __typename?: 'Mutation';
  activateBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  activateModularConfigurator?: Maybe<Scalars['Void']['output']>;
  addCameraToBasicConfiguratorProduct?: Maybe<Scalars['Void']['output']>;
  addCameraToModularConfiguratorComponent?: Maybe<Scalars['Void']['output']>;
  addEnvironmentToBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  addEnvironmentToModularConfigurator?: Maybe<Scalars['Void']['output']>;
  addProductToBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  addProductToModularConfigurator: IdOutput;
  changeBasicConfiguratorEnvironmentLabel?: Maybe<Scalars['Void']['output']>;
  changeBasicConfiguratorEnvironmentPosition?: Maybe<Scalars['Void']['output']>;
  changeBasicConfiguratorProductCollectionLabel?: Maybe<Scalars['Void']['output']>;
  changeBasicConfiguratorProductLabel?: Maybe<Scalars['Void']['output']>;
  changeBasicConfiguratorProductPosition?: Maybe<Scalars['Void']['output']>;
  changeClientUnrealVersion?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentPreview?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentPreviewFromRender?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentSlotLabel?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentSunNorthYaw?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentTitle?: Maybe<Scalars['Void']['output']>;
  changeEnvironmentUdsHour?: Maybe<Scalars['Void']['output']>;
  changeMaterialExternalId?: Maybe<Scalars['Void']['output']>;
  changeMaterialPreview?: Maybe<Scalars['Void']['output']>;
  changeMaterialTitle?: Maybe<Scalars['Void']['output']>;
  changeMetaPropertyType?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorComponentPosition?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorComponentTypePosition?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorEnvironmentLabel?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorEnvironmentPosition?: Maybe<Scalars['Void']['output']>;
  changeModularConfiguratorRootComponentType?: Maybe<Scalars['Void']['output']>;
  changeProductExternalId?: Maybe<Scalars['Void']['output']>;
  changeProductPreview?: Maybe<Scalars['Void']['output']>;
  changeProductPreviewFromRender?: Maybe<Scalars['Void']['output']>;
  changeProductSlotLabel?: Maybe<Scalars['Void']['output']>;
  changeProductTitle?: Maybe<Scalars['Void']['output']>;
  cloneBasicConfigurator: IdOutput;
  cloneEnvironmentToClient: IdOutput;
  cloneMaterialToClient: IdOutput;
  cloneModularConfigurator: IdOutput;
  cloneProductToClient: IdOutput;
  createAssetCreationRequest: CreateAssetCreationRequestOutput;
  createBasicConfigurator: IdOutput;
  createCameraPreset: IdOutput;
  createMetaProperty: IdOutput;
  createModularConfigurator: IdOutput;
  createModularConfiguratorComponent: IdOutput;
  createModularConfiguratorComponentType: IdOutput;
  createModularConfiguratorConnector: IdOutput;
  createModularConfiguratorFromProducts: IdOutput;
  createPreset: Preset;
  createProductVirtualSocket?: Maybe<Scalars['Void']['output']>;
  createRenderRequest: IdOutput;
  createSpinnerRequest: SpinnerRequest;
  deactivateBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  deactivateModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteCameraFromModularConfiguratorComponent?: Maybe<Scalars['Void']['output']>;
  deleteCameraPreset?: Maybe<Scalars['Void']['output']>;
  deleteComponentFromModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteComponentTypeFromModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteConnectorFromModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deleteEnvironment?: Maybe<Scalars['Void']['output']>;
  deleteMaterial?: Maybe<Scalars['Void']['output']>;
  deleteMetaProperty?: Maybe<Scalars['Void']['output']>;
  deleteModularConfigurator?: Maybe<Scalars['Void']['output']>;
  deletePreset?: Maybe<Scalars['Void']['output']>;
  deleteProduct?: Maybe<Scalars['Void']['output']>;
  deleteProductVirtualSocket?: Maybe<Scalars['Void']['output']>;
  deleteRender?: Maybe<Scalars['Void']['output']>;
  deleteSpinner?: Maybe<Scalars['Void']['output']>;
  disableAllMaterialsForEnvironmentSlot?: Maybe<Scalars['Void']['output']>;
  disableAllMaterialsForProductSlot?: Maybe<Scalars['Void']['output']>;
  disableEnvironmentUds?: Maybe<Scalars['Void']['output']>;
  disableMaterialForEnvironmentSlot?: Maybe<Scalars['Void']['output']>;
  disableMaterialForProductSlot?: Maybe<Scalars['Void']['output']>;
  enableEnvironmentUds?: Maybe<Scalars['Void']['output']>;
  enableMaterialForEnvironmentSlot?: Maybe<Scalars['Void']['output']>;
  enableMaterialForProductSlot?: Maybe<Scalars['Void']['output']>;
  enableMaterialsFromAnotherEnvironmentSlot?: Maybe<Scalars['Void']['output']>;
  enableMaterialsFromAnotherProductSlot?: Maybe<Scalars['Void']['output']>;
  importProductsMetaData: ImportProductsMetaDataOutput;
  linkOriginalSocket?: Maybe<Scalars['Void']['output']>;
  login: SymfonyUserImpl;
  logout: Scalars['Boolean']['output'];
  mapModularConfiguratorComponentSocketToConnector?: Maybe<Scalars['Void']['output']>;
  moveEnvironmentMaterial?: Maybe<Scalars['Void']['output']>;
  moveProductMaterial?: Maybe<Scalars['Void']['output']>;
  removeCameraFromBasicConfiguratorProduct?: Maybe<Scalars['Void']['output']>;
  removeEnvironmentFromBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  removeEnvironmentFromModularConfigurator?: Maybe<Scalars['Void']['output']>;
  removeProductFromBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  removeProductMetaProperty?: Maybe<Scalars['Void']['output']>;
  renameBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  renameMetaProperty?: Maybe<Scalars['Void']['output']>;
  renameModularConfigurator?: Maybe<Scalars['Void']['output']>;
  renameModularConfiguratorComponent?: Maybe<Scalars['Void']['output']>;
  renameModularConfiguratorComponentType?: Maybe<Scalars['Void']['output']>;
  renameProductVirtualSocket?: Maybe<Scalars['Void']['output']>;
  setCameraToBasicConfigurator?: Maybe<Scalars['Void']['output']>;
  setCameraToModularConfigurator?: Maybe<Scalars['Void']['output']>;
  setProductLowBandwidthTimecodes?: Maybe<Scalars['Void']['output']>;
  setProductMetaProperty?: Maybe<Scalars['Void']['output']>;
  unlinkOriginalSocket?: Maybe<Scalars['Void']['output']>;
  unmapModularConfiguratorComponentSocketFromConnector?: Maybe<Scalars['Void']['output']>;
  updateEnvironmentModel: UpdateEnvironmentModelOutput;
  updateMaterialModel: UpdateMaterialModelOutput;
  updateProductModel: UpdateProductModelOutput;
}


export interface MutationActivateBasicConfiguratorArgs {
  input: ActivateBasicConfiguratorInput;
}


export interface MutationActivateModularConfiguratorArgs {
  input: ActivateModularConfiguratorInput;
}


export interface MutationAddCameraToBasicConfiguratorProductArgs {
  input: AddCameraToBasicConfiguratorProductInput;
}


export interface MutationAddCameraToModularConfiguratorComponentArgs {
  input: AddCameraToModularConfiguratorComponentInput;
}


export interface MutationAddEnvironmentToBasicConfiguratorArgs {
  input: AddEnvironmentToBasicConfiguratorInput;
}


export interface MutationAddEnvironmentToModularConfiguratorArgs {
  input: AddEnvironmentToModularConfiguratorInput;
}


export interface MutationAddProductToBasicConfiguratorArgs {
  input: AddProductToBasicConfiguratorInput;
}


export interface MutationAddProductToModularConfiguratorArgs {
  input: AddProductToModularConfiguratorInput;
}


export interface MutationChangeBasicConfiguratorEnvironmentLabelArgs {
  input: ChangeBasicConfiguratorEnvironmentLabelInput;
}


export interface MutationChangeBasicConfiguratorEnvironmentPositionArgs {
  input: ChangeBasicConfiguratorEnvironmentPositionInput;
}


export interface MutationChangeBasicConfiguratorProductCollectionLabelArgs {
  input: ChangeBasicConfiguratorProductCollectionLabelInput;
}


export interface MutationChangeBasicConfiguratorProductLabelArgs {
  input: ChangeBasicConfiguratorProductLabelInput;
}


export interface MutationChangeBasicConfiguratorProductPositionArgs {
  input: ChangeBasicConfiguratorProductPositionInput;
}


export interface MutationChangeClientUnrealVersionArgs {
  input: ChangeClientUnrealVersionInput;
}


export interface MutationChangeEnvironmentPreviewArgs {
  input: ChangeEnvironmentPreviewInput;
}


export interface MutationChangeEnvironmentPreviewFromRenderArgs {
  input: ChangeEnvironmentPreviewFromRenderInput;
}


export interface MutationChangeEnvironmentSlotLabelArgs {
  input: ChangeEnvironmentSlotLabelInput;
}


export interface MutationChangeEnvironmentSunNorthYawArgs {
  input: ChangeEnvironmentSunNorthYawInput;
}


export interface MutationChangeEnvironmentTitleArgs {
  input: ChangeEnvironmentTitleInput;
}


export interface MutationChangeEnvironmentUdsHourArgs {
  input: ChangeEnvironmentUdsHourInput;
}


export interface MutationChangeMaterialExternalIdArgs {
  input: ChangeMaterialExternalIdInput;
}


export interface MutationChangeMaterialPreviewArgs {
  input: ChangeMaterialPreviewInput;
}


export interface MutationChangeMaterialTitleArgs {
  input: ChangeMaterialTitleInput;
}


export interface MutationChangeMetaPropertyTypeArgs {
  input: ChangeMetaPropertyTypeInput;
}


export interface MutationChangeModularConfiguratorComponentPositionArgs {
  input: ChangeModularConfiguratorComponentPositionInput;
}


export interface MutationChangeModularConfiguratorComponentTypePositionArgs {
  input: ChangeModularConfiguratorComponentTypePositionInput;
}


export interface MutationChangeModularConfiguratorEnvironmentLabelArgs {
  input: ChangeModularConfiguratorEnvironmentLabelInput;
}


export interface MutationChangeModularConfiguratorEnvironmentPositionArgs {
  input: ChangeModularConfiguratorEnvironmentPositionInput;
}


export interface MutationChangeModularConfiguratorRootComponentTypeArgs {
  input: ChangeModularConfiguratorRootComponentTypeInput;
}


export interface MutationChangeProductExternalIdArgs {
  input: ChangeProductExternalIdInput;
}


export interface MutationChangeProductPreviewArgs {
  input: ChangeProductPreviewInput;
}


export interface MutationChangeProductPreviewFromRenderArgs {
  input: ChangeProductPreviewFromRenderInput;
}


export interface MutationChangeProductSlotLabelArgs {
  input: ChangeProductSlotLabelInput;
}


export interface MutationChangeProductTitleArgs {
  input: ChangeProductTitleInput;
}


export interface MutationCloneBasicConfiguratorArgs {
  input: CloneBasicConfiguratorInput;
}


export interface MutationCloneEnvironmentToClientArgs {
  input: CloneEnvironmentToClientInput;
}


export interface MutationCloneMaterialToClientArgs {
  input: CloneMaterialToClientInput;
}


export interface MutationCloneModularConfiguratorArgs {
  input: CloneModularConfiguratorInput;
}


export interface MutationCloneProductToClientArgs {
  input: CloneProductToClientInput;
}


export interface MutationCreateAssetCreationRequestArgs {
  input: CreateAssetCreationRequestInput;
}


export interface MutationCreateBasicConfiguratorArgs {
  input: CreateBasicConfiguratorInput;
}


export interface MutationCreateCameraPresetArgs {
  input: CreateCameraPresetInput;
}


export interface MutationCreateMetaPropertyArgs {
  input: CreateMetaPropertyInput;
}


export interface MutationCreateModularConfiguratorArgs {
  input: CreateModularConfiguratorInput;
}


export interface MutationCreateModularConfiguratorComponentArgs {
  input: CreateModularConfiguratorComponentInput;
}


export interface MutationCreateModularConfiguratorComponentTypeArgs {
  input: CreateModularConfiguratorComponentTypeInput;
}


export interface MutationCreateModularConfiguratorConnectorArgs {
  input: CreateModularConfiguratorConnectorInput;
}


export interface MutationCreateModularConfiguratorFromProductsArgs {
  input: CreateModularConfiguratorFromProductsInput;
}


export interface MutationCreatePresetArgs {
  input: CreatePresetInput;
}


export interface MutationCreateProductVirtualSocketArgs {
  input: CreateProductVirtualSocketInput;
}


export interface MutationCreateRenderRequestArgs {
  input: CreateRenderRequestInput;
}


export interface MutationCreateSpinnerRequestArgs {
  input: CreateSpinnerRequestInput;
}


export interface MutationDeactivateBasicConfiguratorArgs {
  input: DeactivateBasicConfiguratorInput;
}


export interface MutationDeactivateModularConfiguratorArgs {
  input: DeactivateModularConfiguratorInput;
}


export interface MutationDeleteBasicConfiguratorArgs {
  input: DeleteBasicConfiguratorInput;
}


export interface MutationDeleteCameraFromModularConfiguratorComponentArgs {
  input: DeleteCameraFromModularConfiguratorComponentInput;
}


export interface MutationDeleteCameraPresetArgs {
  input: DeleteCameraPresetInput;
}


export interface MutationDeleteComponentFromModularConfiguratorArgs {
  input: DeleteComponentFromModularConfiguratorInput;
}


export interface MutationDeleteComponentTypeFromModularConfiguratorArgs {
  input: DeleteComponentTypeFromModularConfiguratorInput;
}


export interface MutationDeleteConnectorFromModularConfiguratorArgs {
  input: DeleteConnectorFromModularConfiguratorInput;
}


export interface MutationDeleteEnvironmentArgs {
  input: DeleteEnvironmentInput;
}


export interface MutationDeleteMaterialArgs {
  input: DeleteMaterialInput;
}


export interface MutationDeleteMetaPropertyArgs {
  input: DeleteMetaPropertyInput;
}


export interface MutationDeleteModularConfiguratorArgs {
  input: DeleteModularConfiguratorInput;
}


export interface MutationDeletePresetArgs {
  input: DeletePresetInput;
}


export interface MutationDeleteProductArgs {
  input: DeleteProductInput;
}


export interface MutationDeleteProductVirtualSocketArgs {
  input: DeleteProductVirtualSocketInput;
}


export interface MutationDeleteRenderArgs {
  input: DeleteRenderInput;
}


export interface MutationDeleteSpinnerArgs {
  input: DeleteSpinnerInput;
}


export interface MutationDisableAllMaterialsForEnvironmentSlotArgs {
  input: DisableAllMaterialsForEnvironmentSlotInput;
}


export interface MutationDisableAllMaterialsForProductSlotArgs {
  input: DisableAllMaterialsForProductSlotInput;
}


export interface MutationDisableEnvironmentUdsArgs {
  input: DisableEnvironmentUdsInput;
}


export interface MutationDisableMaterialForEnvironmentSlotArgs {
  input: DisableMaterialForEnvironmentSlotInput;
}


export interface MutationDisableMaterialForProductSlotArgs {
  input: DisableMaterialForProductSlotInput;
}


export interface MutationEnableEnvironmentUdsArgs {
  input: EnableEnvironmentUdsInput;
}


export interface MutationEnableMaterialForEnvironmentSlotArgs {
  input: EnableMaterialForEnvironmentSlotInput;
}


export interface MutationEnableMaterialForProductSlotArgs {
  input: EnableMaterialForProductSlotInput;
}


export interface MutationEnableMaterialsFromAnotherEnvironmentSlotArgs {
  input: EnableMaterialsFromAnotherEnvironmentSlotInput;
}


export interface MutationEnableMaterialsFromAnotherProductSlotArgs {
  input: EnableMaterialsFromAnotherProductSlotInput;
}


export interface MutationImportProductsMetaDataArgs {
  input: ImportProductsMetaDataInput;
}


export interface MutationLinkOriginalSocketArgs {
  input: LinkOriginalSocketInput;
}


export interface MutationLoginArgs {
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
}


export interface MutationMapModularConfiguratorComponentSocketToConnectorArgs {
  input: MapModularConfiguratorComponentSocketToConnectorInput;
}


export interface MutationMoveEnvironmentMaterialArgs {
  input: MoveEnvironmentMaterialInput;
}


export interface MutationMoveProductMaterialArgs {
  input: MoveProductMaterialInput;
}


export interface MutationRemoveCameraFromBasicConfiguratorProductArgs {
  input: RemoveCameraFromBasicConfiguratorProductInput;
}


export interface MutationRemoveEnvironmentFromBasicConfiguratorArgs {
  input: RemoveEnvironmentFromBasicConfiguratorInput;
}


export interface MutationRemoveEnvironmentFromModularConfiguratorArgs {
  input: RemoveEnvironmentFromModularConfiguratorInput;
}


export interface MutationRemoveProductFromBasicConfiguratorArgs {
  input: RemoveProductFromBasicConfiguratorInput;
}


export interface MutationRemoveProductMetaPropertyArgs {
  input: RemoveProductMetaPropertyInput;
}


export interface MutationRenameBasicConfiguratorArgs {
  input: RenameBasicConfiguratorInput;
}


export interface MutationRenameMetaPropertyArgs {
  input: RenameMetaPropertyInput;
}


export interface MutationRenameModularConfiguratorArgs {
  input: RenameModularConfiguratorInput;
}


export interface MutationRenameModularConfiguratorComponentArgs {
  input: RenameModularConfiguratorComponentInput;
}


export interface MutationRenameModularConfiguratorComponentTypeArgs {
  input: RenameModularConfiguratorComponentTypeInput;
}


export interface MutationRenameProductVirtualSocketArgs {
  input: RenameProductVirtualSocketInput;
}


export interface MutationSetCameraToBasicConfiguratorArgs {
  input: SetCameraToBasicConfiguratorInput;
}


export interface MutationSetCameraToModularConfiguratorArgs {
  input: SetCameraToModularConfiguratorInput;
}


export interface MutationSetProductLowBandwidthTimecodesArgs {
  input: SetProductLowBandwidthTimecodesInput;
}


export interface MutationSetProductMetaPropertyArgs {
  input: SetProductMetaPropertyInput;
}


export interface MutationUnlinkOriginalSocketArgs {
  input: UnlinkOriginalSocketInput;
}


export interface MutationUnmapModularConfiguratorComponentSocketFromConnectorArgs {
  input: UnmapModularConfiguratorComponentSocketFromConnectorInput;
}


export interface MutationUpdateEnvironmentModelArgs {
  input: UpdateEnvironmentModelInput;
}


export interface MutationUpdateMaterialModelArgs {
  input: UpdateMaterialModelInput;
}


export interface MutationUpdateProductModelArgs {
  input: UpdateProductModelInput;
}

export interface Preset {
  __typename?: 'Preset';
  config: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  environment: Environment;
  id: Scalars['ID']['output'];
  previewPath?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface Product {
  __typename?: 'Product';
  cameraPresets: CameraPresetListType;
  clientId: Scalars['ID']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  hasShowcase: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  legacyAssetId: Scalars['ID']['output'];
  metaProperties: Array<ProductMetaProperty>;
  model: Model;
  modelId: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<ProductType>;
  renders: RenderListType;
  showcase?: Maybe<Showcase>;
  slots: Array<Slot>;
  spinners: SpinnerListType;
  thumbnailList: Array<Thumbnail>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  virtualSockets: Array<VirtualSocket>;
}


export interface ProductCameraPresetsArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface ProductRendersArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface ProductSpinnersArgs {
  countTotal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface ProductMetaProperty {
  __typename?: 'ProductMetaProperty';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface ProductType {
  __typename?: 'ProductType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface Query {
  __typename?: 'Query';
  assetCreationRequestList: GetAssetCreationRequestListOutput;
  basicConfigurator: BasicConfigurator;
  basicConfiguratorList: GetBasicConfiguratorListOutput;
  client: Client;
  clientList: GetClientListOutput;
  environment: Environment;
  environmentList: GetEnvironmentListOutput;
  material: Material;
  materialList: GetMaterialListOutput;
  me?: Maybe<SymfonyUserImpl>;
  metaPropertyList: GetMetaPropertyListOutput;
  modularConfigurator: ModularConfigurator;
  modularConfiguratorList: GetModularConfiguratorListOutput;
  presetList: GetPresetListOutput;
  product: Product;
  productList: GetProductListOutput;
  render: Render;
  renderList: RenderListType;
  renderRequest: RenderRequest;
  spinner: Spinner;
}


export interface QueryAssetCreationRequestListArgs {
  input: GetAssetCreationRequestListInput;
}


export interface QueryBasicConfiguratorArgs {
  input: GetBasicConfiguratorInput;
}


export interface QueryBasicConfiguratorListArgs {
  input: GetBasicConfiguratorListInput;
}


export interface QueryClientArgs {
  input: GetClientInput;
}


export interface QueryClientListArgs {
  input: GetClientListInput;
}


export interface QueryEnvironmentArgs {
  input: GetEnvironmentInput;
}


export interface QueryEnvironmentListArgs {
  input: GetEnvironmentListInput;
}


export interface QueryMaterialArgs {
  input: GetMaterialInput;
}


export interface QueryMaterialListArgs {
  input: GetMaterialListInput;
}


export interface QueryMetaPropertyListArgs {
  input: GetMetaPropertyListInput;
}


export interface QueryModularConfiguratorArgs {
  input: GetModularConfiguratorInput;
}


export interface QueryModularConfiguratorListArgs {
  input: GetModularConfiguratorListInput;
}


export interface QueryPresetListArgs {
  input: GetPresetListInput;
}


export interface QueryProductArgs {
  input: GetProductInput;
}


export interface QueryProductListArgs {
  input: GetProductListInput;
}


export interface QueryRenderArgs {
  input: GetRenderInput;
}


export interface QueryRenderListArgs {
  input: GetRenderListInput;
}


export interface QueryRenderRequestArgs {
  input: GetRenderRequestInput;
}


export interface QuerySpinnerArgs {
  input: GetSpinnerInput;
}

export interface RadiusVector {
  __typename?: 'RadiusVector';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
}

export interface RadiusVectorInput {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
}

export interface RemoveCameraFromBasicConfiguratorProductInput {
  configuratorId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}

export interface RemoveEnvironmentFromBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
}

export interface RemoveEnvironmentFromModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  environmentId: Scalars['ID']['input'];
}

export interface RemoveProductFromBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}

export interface RemoveProductMetaPropertyInput {
  metaPropertyId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
}

export interface RenameBasicConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameMetaPropertyInput {
  metaPropertyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameModularConfiguratorComponentInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameModularConfiguratorComponentTypeInput {
  componentTypeId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameModularConfiguratorInput {
  configuratorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}

export interface RenameProductVirtualSocketInput {
  name: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['ID']['input']>;
  virtualSocketId?: InputMaybe<Scalars['ID']['input']>;
}

export interface Render {
  __typename?: 'Render';
  executionTime: Scalars['Int']['output'];
  filePath: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  fullSizePreviewPath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  renderRequest: RenderRequest;
}

export interface RenderListType {
  __typename?: 'RenderListType';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  renders: Array<Render>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface RenderRequest {
  __typename?: 'RenderRequest';
  author?: Maybe<User>;
  background?: Maybe<Scalars['String']['output']>;
  configuration?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Environment>;
  fileType: RenderRequestFileTypeEnum;
  fov: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isAsyncMode: Scalars['Boolean']['output'];
  mode: RenderRequestModeEnum;
  previewPath?: Maybe<Scalars['String']['output']>;
  products: Array<Product>;
  renderId?: Maybe<Scalars['ID']['output']>;
  renderResultUrl: Scalars['String']['output'];
  serialNumber: Scalars['Int']['output'];
  status: RequestStatusEnum;
  width: Scalars['Int']['output'];
}

export enum RenderRequestFileTypeEnum {
  Jpg = 'jpg',
  Png = 'png',
  Tiff = 'tiff'
}

export enum RenderRequestModeEnum {
  Ai = 'ai',
  Unreal = 'unreal'
}

export enum RequestStatusEnum {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  New = 'new'
}

export interface Restrictions {
  __typename?: 'Restrictions';
  maxPitch?: Maybe<Scalars['Float']['output']>;
  maxYaw?: Maybe<Scalars['Float']['output']>;
  maxZoom?: Maybe<Scalars['Float']['output']>;
  minPitch?: Maybe<Scalars['Float']['output']>;
  minYaw?: Maybe<Scalars['Float']['output']>;
  minZoom?: Maybe<Scalars['Float']['output']>;
  panBoundariesBox?: Maybe<BoundariesBox>;
  panBoundariesRadius?: Maybe<Scalars['Float']['output']>;
}

export interface RestrictionsInput {
  maxPitch?: InputMaybe<Scalars['Float']['input']>;
  maxYaw?: InputMaybe<Scalars['Float']['input']>;
  maxZoom?: InputMaybe<Scalars['Float']['input']>;
  minPitch?: InputMaybe<Scalars['Float']['input']>;
  minYaw?: InputMaybe<Scalars['Float']['input']>;
  minZoom?: InputMaybe<Scalars['Float']['input']>;
  panBoundariesBox?: InputMaybe<BoundariesBoxInput>;
  panBoundariesRadius?: InputMaybe<Scalars['Float']['input']>;
}

export interface Rotation {
  __typename?: 'Rotation';
  pitch: Scalars['Float']['output'];
  roll: Scalars['Float']['output'];
  yaw: Scalars['Float']['output'];
}

export interface RotationInput {
  pitch: Scalars['Float']['input'];
  roll: Scalars['Float']['input'];
  yaw: Scalars['Float']['input'];
}

export interface SetCameraToBasicConfiguratorInput {
  camera: CameraInput;
  configuratorId: Scalars['ID']['input'];
}

export interface SetCameraToModularConfiguratorInput {
  camera: CameraInput;
  configuratorId: Scalars['ID']['input'];
}

export interface SetProductLowBandwidthTimecodesInput {
  productId: Scalars['ID']['input'];
  timecodes: Array<Scalars['Float']['input']>;
}

export interface SetProductMetaPropertyInput {
  metaPropertyId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
}

export interface Showcase {
  __typename?: 'Showcase';
  duration?: Maybe<Scalars['Float']['output']>;
  lowBandwidth: Array<Timecode>;
}

export interface Slot {
  __typename?: 'Slot';
  enabledMaterials: Array<Material>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
}

export interface Spinner {
  __typename?: 'Spinner';
  defaultX: Scalars['Int']['output'];
  endX: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  maskX: Scalars['String']['output'];
  path: Scalars['String']['output'];
  startX: Scalars['Int']['output'];
  status: RequestStatusEnum;
  template: Scalars['String']['output'];
}

export interface SpinnerListType {
  __typename?: 'SpinnerListType';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  spinners: Array<Spinner>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface SpinnerRequest {
  __typename?: 'SpinnerRequest';
  id: Scalars['ID']['output'];
  spinnerId: Scalars['ID']['output'];
  status: RequestStatusEnum;
  uploadUrl: Scalars['String']['output'];
}

export interface SymfonyUserImpl extends SymfonyUserInterface {
  __typename?: 'SymfonyUserImpl';
  roles: Array<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
}

export interface SymfonyUserInterface {
  roles: Array<Scalars['String']['output']>;
  userName: Scalars['String']['output'];
}

export interface Thumbnail {
  __typename?: 'Thumbnail';
  height: Scalars['Int']['output'];
  urlPath: Scalars['String']['output'];
  width: Scalars['Int']['output'];
}

export interface Time {
  __typename?: 'Time';
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
  second: Scalars['Int']['output'];
}

export interface Timecode {
  __typename?: 'Timecode';
  duration: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
}

export interface UnlinkOriginalSocketInput {
  originalSocket: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  virtualSocketId: Scalars['String']['input'];
}

export interface UnmapModularConfiguratorComponentSocketFromConnectorInput {
  componentId: Scalars['ID']['input'];
  configuratorId: Scalars['ID']['input'];
  connectorId: Scalars['ID']['input'];
  socketId: Scalars['ID']['input'];
}

export enum UnrealVersion {
  V_51 = 'v_51',
  V_53 = 'v_53'
}

export interface UpdateEnvironmentModelInput {
  chunkNumber: Scalars['Int']['input'];
  environmentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  totalChunks: Scalars['Int']['input'];
  uploadId: Scalars['ID']['input'];
}

export interface UpdateEnvironmentModelOutput {
  __typename?: 'UpdateEnvironmentModelOutput';
  completed: Scalars['Boolean']['output'];
}

export interface UpdateMaterialModelInput {
  chunkNumber: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  materialId: Scalars['ID']['input'];
  totalChunks: Scalars['Int']['input'];
  uploadId: Scalars['ID']['input'];
}

export interface UpdateMaterialModelOutput {
  __typename?: 'UpdateMaterialModelOutput';
  completed: Scalars['Boolean']['output'];
}

export interface UpdateProductModelInput {
  chunkNumber: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  productId: Scalars['ID']['input'];
  totalChunks: Scalars['Int']['input'];
  uploadId: Scalars['ID']['input'];
}

export interface UpdateProductModelOutput {
  __typename?: 'UpdateProductModelOutput';
  completed: Scalars['Boolean']['output'];
}

export interface User {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
}

export interface VirtualSocket {
  __typename?: 'VirtualSocket';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  originalSockets: Array<Scalars['String']['output']>;
}
